// extracted by mini-css-extract-plugin
module.exports = {"spotReportSummary":"SpotReportSummary_spotReportSummary__WTvYK"};